import * as React from 'react';
import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import { InlineText1 } from '@cian/ui-kit/typography';
import * as styles from './NoImage.css';

export const NoImage = () => {
  return (
    <div className={styles['image']}>
      <div className={styles['image-icon']}>
        <IconPlaceholderImages24 display="block" color="white_60" />
      </div>
      <InlineText1 fontWeight={'bold'} color={'gray60_100'}>
        Нет фото
      </InlineText1>
    </div>
  );
};
